import { Button } from "@material-ui/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPayloadForFetchSoundLists } from "..";
import { toAbsoluteUrl } from "../../../../../../../Utils/_helpers";
import { actions } from "../../../../../Dashboard/_redux/dashboardRedux";
import {
  deleteSound,
  fetchTTSSoundsLists,
  setCurrentPage,
  setSelectedSounds,
  setSoundListingApiPayload,
} from "../../../../state/slices/soundsSlice";

const DeleteSoundPopupContent = ({
  sound,
  handleCloseDeletePopup,
  selectedSoundList = [],
  setToastValue = () => {},
}) => {
  const dispatch = useDispatch();

  const selectedManageSoundTab = useSelector(
    (state) => state.soundsSlice.activeSoundTab
  );

  const soundsMetaData = useSelector(
    (state) => state.soundsSlice.soundListMetaData
  );

  const { pageSize, currentPage } = useSelector((state) => state.soundsSlice);

  const searchQuery = useSelector((state) => state.soundsSlice.searchQuery);

  const soundDelete = (selectedSound) => {
    dispatch(
      actions.setLoadingState({
        resource: "sound_lists",
        loading_state: "loading",
      })
    );
    dispatch(deleteSound(selectedSound?.id)).then((res) => {
      const totalCount = soundsMetaData?.total_count || 0;
      if (!res.error) {
        setToastValue(true, "Sound Deleted successfully", "success");
        setTimeout(() => {
          let payload = setPayloadForFetchSoundLists(
            1,
            pageSize,
            selectedManageSoundTab
          );
          payload = {
            ...payload,
            ...(searchQuery && {
              soundlibobj__soundname__icontains: searchQuery,
            }),
            total_entries: totalCount,
            total_pages: Math.ceil(totalCount / pageSize),
          };
          if (currentPage > 1) {
            dispatch(setSoundListingApiPayload(payload));
            dispatch(setCurrentPage(1));
          } else {
            dispatch(fetchTTSSoundsLists(payload));
          }
        }, 800);
      } else {
        dispatch(
          actions.setLoadingState({
            resource: "sound_lists",
            loading_state: "loaded",
          })
        );
        setToastValue(true, res?.payload.error, "error");
      }
    });
  };

  const handleDeleteSound = () => {
    if (selectedSoundList.length) {
      selectedSoundList.forEach((soundObj) => {
        soundDelete(soundObj);
      });
      dispatch(setSelectedSounds([]));
    } else {
      soundDelete(sound);
    }

    handleCloseDeletePopup();
  };

  return (
    <div className="d-flex flex-column align-items-center p-5">
      <div className="mb-10 d-flex flex-column align-items-center text-center">
        <img
          alt="close"
          src={toAbsoluteUrl("/media/sr/icons/error.svg")}
          style={{ width: "48px", height: "48px" }}
        />
        <span
          className="mt-5 mb-2"
          style={{ fontSize: "16px", fontWeight: 500 }}
        >
          <span>
            {sound ? (
              <strong>{`Do you want to delete the sound - ${sound?.soundlibobj?.soundname} ?`}</strong>
            ) : (
              <strong>{`Delete Selected(${selectedSoundList.length}) Sounds`}</strong>
            )}
          </span>
        </span>
        <span style={{ fontSize: "12px", fontWeight: 500, color: "#464e5f" }}>
          {`Active sound cannot be deleted. Make sure it's not in use`}
        </span>
      </div>

      <div className="d-flex">
        <Button
          onClick={() => {
            handleCloseDeletePopup();
          }}
          style={{ border: "1px solid", width: "104px" }}
          className="outline-btn mr-2 ml-2 text-capitalize contained-btn "
        >
          No
        </Button>
        <Button
          style={{ border: "1px solid", width: "104px" }}
          onClick={() => {
            handleDeleteSound();
          }}
          className="sr-btn mr-2 ml-2 text-capitalize contained-btn"
        >
          Yes
        </Button>
      </div>
    </div>
  );
};

export default DeleteSoundPopupContent;
